import { useEffect, useState } from 'react';

const FIELDS = ['INPUT', 'TEXTAREA', 'SELECT'];

/**
 * True while the visitor is typing in a form field. The sticky bar hides then,
 * because on a phone it sits exactly where the keyboard pushes the field.
 */
export function useFieldFocused(): boolean {
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    const isField = (target: EventTarget | null) =>
      target instanceof HTMLElement &&
      (FIELDS.includes(target.tagName) || target.isContentEditable);

    const onFocus = (e: FocusEvent) => isField(e.target) && setFocused(true);
    const onBlur = (e: FocusEvent) => isField(e.target) && setFocused(false);

    document.addEventListener('focusin', onFocus);
    document.addEventListener('focusout', onBlur);
    return () => {
      document.removeEventListener('focusin', onFocus);
      document.removeEventListener('focusout', onBlur);
    };
  }, []);

  return focused;
}
